import { useEffect } from 'react';
import { CheckCircle2, Info, TriangleAlert, X } from 'lucide-react';
import { useUI } from '@/data/stores';

export function ActionNotice() {
  const notice = useUI((s) => s.actionNotice);
  const clear = useUI((s) => s.clearActionNotice);

  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(() => clear(notice.id), 3600);
    return () => window.clearTimeout(timer);
  }, [clear, notice]);

  if (!notice) return null;

  const Icon =
    notice.kind === 'success'
      ? CheckCircle2
      : notice.kind === 'warning'
        ? TriangleAlert
        : Info;

  return (
    <div className={`iris-action-notice ${notice.kind ?? 'info'}`} role="status">
      <Icon size={16} strokeWidth={1.6} />
      <div>
        <div className="iris-action-notice-title">{notice.title}</div>
        {notice.body && <div className="iris-action-notice-body">{notice.body}</div>}
      </div>
      <button aria-label="Dismiss notice" onClick={() => clear(notice.id)}>
        <X size={14} strokeWidth={1.6} />
      </button>
    </div>
  );
}
